//store.js
import Vue from 'vue'
import Vuex from 'vuex'

// 头部分类
import detail from './modules/detail';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    detail,
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js